// Auto-generated by scripts/build-gallery-usage.ts
// checksum: 294386ec
import type { Manifest } from './manifest.schema'
import {
  galleryPayload,
  galleryPreviewModules,
  galleryPreviewRoutes,
} from './generated-manifest'

export const manifest = {
  galleryPayload,
  galleryPreviewModules,
  galleryPreviewRoutes,
} as const satisfies Manifest

export { galleryPayload, galleryPreviewModules, galleryPreviewRoutes }

export default manifest

